import { ApplicationTypes, attachComponent } from 'sunlife-domain'

import { finalizePageComponent, memoEval, propertyPageComponent } from '@salsita-ai/platform-project-sdk/domain'
import { Dialog } from '@salsita-ai/platform-project-sdk/ui'

import { DesignProperties } from '../ui/DesignProperties'
import { DrawStringProperties } from '../ui/DrawStringProperties'
import { ShortsProperties } from '../ui/ShortsProperties'
// import { SunlifeShortsProperties } from '../ui/SunlifeShortsProperties'
import FinalizeCartDialog from '../ui/finalize/FinalizeCartDialog'
import FinalizeWishlistDialog from '../ui/finalize/FinalizeWishlistDialog'

export const sidebarComponents = [
  // TEMPORARY: Hide pattern selector to not allow changing to the Board shorts until they are manufacturable.
  // attachComponent
  //   .withAlias('SunlifeShorts')
  //   .withComponent(propertyPageComponent, 'sunlifeShortsProperties')
  //   .attach(self => ({
  //     page: <SunlifeShortsProperties entity={self} />,
  //   })),
  attachComponent
    .withAlias('WithDesign')
    .withComponent(propertyPageComponent, 'designProperties')
    .attach(self => ({
      page: <DesignProperties entity={self} />,
    })),
  attachComponent
    .withAlias('Shorts')
    .withComponent(propertyPageComponent, 'shortsProperties')
    .attach(self => ({
      page: <ShortsProperties entity={self} />,
    })),
  attachComponent
    .withEntity('Drawstring')
    .withComponent(propertyPageComponent, 'drawStringProperties')
    .attach(self => ({
      page: <DrawStringProperties entity={self} />,
    })),
  attachComponent
    .withAlias('Shorts')
    .withComponent(finalizePageComponent, 'finalize-cart')
    .attach(
      memoEval(
        () => [],
        () => ({
          page: (
            <Dialog.Root variant="static" sx={{ width: '70%', maxWidth: '500px' }}>
              <FinalizeCartDialog />
            </Dialog.Root>
          ),
          finalizeNavigationStates: [ApplicationTypes.NavigationState.FinalizeCart],
        })
      )
    ),
  attachComponent
    .withAlias('Shorts')
    .withComponent(propertyPageComponent, 'finalize-wishlist')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.FinalizeWishlist],
    })
    .attach(
      memoEval(
        () => [],
        () => ({
          page: (
            <Dialog.Root variant="static" sx={{ width: '70%', maxWidth: '500px' }}>
              <FinalizeWishlistDialog />
            </Dialog.Root>
          ),
        })
      )
    ),
]
